module.exports = __webpack_public_path__ + "fd8ecbd59a44970c92bdd5e928ce4b1d.png";